const GRAPH_COLORS = {
  DARK_BLUE: 'rgba(0, 82, 231, 0.8)',
  LIGHT_BLUE: 'rgba(76, 190, 231, 1)',
  BORDER_COLOR: 'rgb(255, 99, 132)'
}

export {
  GRAPH_COLORS
}
// hello
// there jake
// again



// WEBPACK FOOTER //
// ./src/app/appLogic/appConstants/ColorSchema.js